import { create } from 'zustand';

/**
 * AIチャット → メモページ間で「このスレッドを引用してメモを作成」を受け渡すための
 * 一時的なストア。永続化しない。
 *
 * メモ本体は backend API（useListProjectMemos 等）で管理する。
 */
type ProjectMemoStore = {
  pendingThreadId: string | undefined;
  setPendingThreadId: (threadId: string | undefined) => void;
};

export const useProjectMemoStore = create<ProjectMemoStore>()((set) => ({
  pendingThreadId: undefined,
  setPendingThreadId: (threadId) => {
    set({ pendingThreadId: threadId });
  },
}));
